import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Building2, Crown, Sparkles } from 'lucide-react';
import { useUser } from '../../../../UserContext';
import { getMembershipCapabilities } from '../../../../utils/membershipCapabilities';
import '../DashboardHome.css';

const HomeSubscribe = () => {
    const { user } = useUser();
    const capabilities = getMembershipCapabilities(user?.subscription);

    if (capabilities.isPaid) {
        return (
            <div className='home-subscribe'>
                <div className="home-subscribe-heading">
                    {capabilities.isVenue ? <Building2 size={24} color="#12715B" /> : <Crown size={24} color="#FF6A00" />}
                    <h1>You're on the <span>{capabilities.tier}</span> plan</h1>
                </div>
                <p className="home-subscribe-summary home-subscribe-summary-paid">
                    {capabilities.memberSummary}
                </p>
            </div>
        );
    }

    return (
        <div className='home-subscribe'>
            <div className="home-subscribe-heading compact">
                <Sparkles size={22} color="#FF6A00" />
                <h1>Free gets you started. <span>Premium</span> goes deeper.</h1>
            </div>
            <p className="home-subscribe-summary">
                Marketplace, venue discovery, blogs, and news stay open on Free. {capabilities.upgradePrompt}
            </p>
            <Link to="/dashboard/subscription" className="home-subscribe-link">
                Learn More <ArrowRight size={16} />
            </Link>
        </div>
    );
};

export default HomeSubscribe;
